import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ShapeListItem from './ShapeListItem';

const DraggableShapeListItem = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.id });

  const [isHovered, setIsHovered] = useState(false);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 100 : 'auto',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '20px auto',
    padding: '0px',
    marginBottom: '5px',
    backgroundColor: 'transparent',
    paddingRight: '5px',
  };

  const wristStyle = {
    cursor: 'grab',
    padding: '0px',
    opacity: isHovered ? 1 : 0,
    transition: 'opacity 120ms, padding 120ms, min-width 120ms',
    overflow: 'hidden',
    height: '30px',
    width: '20px',
    marginBottom: '0px',
    color: 'var(--pico-switch-color)',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className='wrist' style={wristStyle} {...listeners}>
        ⠿
      </div>
      <ShapeListItem {...props} />
    </div>
  );
};

export default DraggableShapeListItem;